<div class="theme-selection-area background-tabs scoot-home-v1 presentation-v2">
  <p class="area-title">Background</p>
  <mat-tab-group [(selectedIndex)]="currentTabIndex" (selectedIndexChange)="tabChanged($event)">
    @for (themeTab of themeTabs; track themeTab) {
      <mat-tab
        [label]="themeTab.themeCategory.name ? themeTab.themeCategory.name : ''"
        [id]="themeTab.themeCategory.socialThemeCategoryId"
      >
        @if (themeTab.themeCategory.description) {
          <span class="theme-description-label">
            {{ themeTab.themeCategory.description }}
          </span>
        }
        <ngb-carousel
          [interval]="0"
          #themeCarousel
          [id]="currentTabIndex"
          [activeId]="'id_' + social?.themeId"
          (slide)="onSlide($event)"
        >
          @for (theme of themeTab.themes; track theme) {
            <ng-template ngbSlide [id]="'id_' + theme.socialThemeId">
              <div class="theme-label">
                <p>{{ theme.socialThemeName }}</p>
              </div>
              <!-- Layered Backgrounds -->
              @if (!theme.minimapImageURI) {
                <div
                  class="theme-image"
                  [style.background-color]="safeStyleAttribute(theme.colorBackground)"
                  [style.background]="safeStyleAttribute(theme.colorGradientBackground)"
                >
                  <img class="far-layer" [src]="theme.imageFarURI" alt="" />
                  <img class="mid-layer" [src]="theme.imageMidURI" alt="" />
                  <img class="near-layer" [src]="theme.imageNearURI" alt="" />
                </div>
              }
              <!-- Contiguous Backgrounds -->
              @if (theme.minimapImageURI) {
                <div class="theme-image">
                  <img class="contiguous-image" [src]="theme.minimapImageURI" alt="" />
                </div>
              }
            </ng-template>
          }
        </ngb-carousel>
      </mat-tab>
    }
  </mat-tab-group>
</div>
